import React, {useContext, useEffect, useState} from 'react';
import './Button.scss'
import { ConfigContext } from '../../screens/form/DynamicForm/DynamicForm';

const Button = ({label, onClick, classes, type='button', icon, style, localError}) => {
  
  const [buttonType, setButtonType] = useState(type)
  
  // imports context object
  const context = useContext(ConfigContext)

  useEffect(()=>{
    context && context.localError ? setButtonType('button') : setButtonType(type)  
  })
  
  return (
    <button className={`button ${classes}`} onClick={onClick} style={context ? {backgroundColor: context.dbFormSpec.color} : {backgroundColor: style.backgroundColor}} type={buttonType}>
        {/* Icons are not presently being used, but may be in the future */}
        {icon && 'test'}
        <p className="button-text">{label}</p>
    </button>
  )
}

export default Button;